import React from "react";
import localeText from "../../../../../../../locale";
import FileDropzone from "./FileDropzone";
import { formatFileSize } from "../utils";

function DigitalFileCard({
  icon,
  title,
  required,
  help,
  formats,
  sizeLabel,
  file,
  onSelect,
  onRemove,
  accept,
  maxBytes,
  isImage,
}) {
  const preview =
    file?.previewUrl || (isImage && file instanceof Blob ? URL.createObjectURL(file) : null);
  const name = file?.name || file?.fileName || "";
  const size = file?.size ?? file?.fileSize;

  return (
    <div className="product-form-digital-card">
      <div className="flex h-full" style={{ gap: "0.75rem" }}>
        <div className="hidden md:block">
          <span className="product-form-digital-icon flex align-items-center justify-content-center">
            {icon}
          </span>
        </div>
        <div className="flex flex-column justify-content-between gap-2 h-full">
          <div>
            <label className="product-form-label-digital">
              {title}
              {required ? <span className="product-form-required">*</span> : null}
            </label>
            <p className="product-form-help-digital">{help}</p>
          </div>
          <div className="text-sm font-medium flex flex-column gap-2">
            <div className="product-form-formats">
              {" "}
              <i className="pi pi-file mr-1 text-sm" /> {formats}
            </div>
            <div className="product-form-formats">
              <i className="pi pi-chart-pie mr-1 text-sm" /> {sizeLabel}
            </div>
          </div>
        </div>
      </div>
      {file ? (
        <div className="product-form-digital-success">
          <div className="flex align-items-start gap-3">
            <div className="product-form-file-thumb">
              {isImage && preview ? <img src={preview} alt="" /> : <i className="pi pi-file" />}
            </div>
            <div className="product-form-file-info">
              <div className="product-form-file-name text-regular font-bold">{name || "—"}</div>
              {size != null ? (
                <div className="product-form-help-digital">{formatFileSize(size)}</div>
              ) : null}
              <div className="flex align-items-center mt-2">
                <div
                  className="text-xs border-round-md px-2 py-1 font-medium"
                  style={{
                    backgroundColor:
                      "color-mix(in srgb, var(--theme-border) 10%, var(--theme-background))",
                    border: "1px solid var(--theme-border)",
                  }}
                >
                  <i
                    className="pi pi-check-circle mr-1 text-xs"
                    style={{ color: "var(--theme-primary)" }}
                  />{" "}
                  {localeText("uploadedSuccessfully")}
                </div>
              </div>
            </div>
          </div>
          <hr className="my-3" />
          <div className="flex justify-content-between mt-3">
            <button type="button" className="product-form-link-dropzone text-sm font-medium" onClick={onRemove}>
              <i className="pi pi-cloud-upload mr-1 text-lg" />
              {localeText("replaceFile")}
            </button>
            {file?.previewUrl || file?.url ? (
              <a
                className="product-form-link-dropzone text-sm font-medium"
                href={file.previewUrl || file.url}
                target="_blank"
                rel="noreferrer"
              >
                <i className="pi pi-eye mr-1" />
                {localeText("viewFile")}
              </a>
            ) : null}
            <button
              type="button"
              className="product-form-link-dropzone text-sm font-medium"
              style={{ color: "#d32f2f" }}
              onClick={onRemove}
            >
              <i className="pi pi-trash mr-1" />
              {localeText("remove")}
            </button>
          </div>
        </div>
      ) : (
        <FileDropzone
          accept={accept}
          multiple={false}
          onSelect={(files) => onSelect(files)}
          titleKey="dragDropOrSelect"
          helpKey="uploadZoneHelp"
          formatsKey={null}
          buttonKey="selectFiles"
          maxBytes={maxBytes}
        />
      )}
    </div>
  );
}

export default DigitalFileCard;
